var React = require('react');

function ExpandUpDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 28.5A1.5 1.5 0 011.5 27h45a1.5 1.5 0 010 3h-45A1.5 1.5 0 010 28.5zm0-9A1.5 1.5 0 011.5 18h45a1.5 1.5 0 010 3h-45A1.5 1.5 0 010 19.5z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 0a1.5 1.5 0 011.5 1.5v18a1.5 1.5 0 01-3 0v-18A1.5 1.5 0 0124 0zm0 27a1.5 1.5 0 011.5 1.5v18a1.5 1.5 0 01-3 0v-18A1.5 1.5 0 0124 27z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.94.44a1.5 1.5 0 012.12 0l7.5 7.5a1.5 1.5 0 01-2.12 2.12L24 3.622l-6.44 6.44a1.5 1.5 0 01-2.12-2.122l7.5-7.5zm-7.5 37.5a1.5 1.5 0 012.12 0L24 44.378l6.44-6.44a1.5 1.5 0 012.12 2.122l-7.5 7.5a1.5 1.5 0 01-2.12 0l-7.5-7.5a1.5 1.5 0 010-2.122z","key":2})]);
}

ExpandUpDown.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ExpandUpDown;

ExpandUpDown.default = ExpandUpDown;
